import styled, { createGlobalStyle, css } from 'styled-components';
import { normalize } from 'styled-normalize';

import '@speeki/wysiwyg-editor/build/styles.css';

import { breakpoints } from '@shared/constants';

export const GlobalStyled = createGlobalStyle<{
    blockScroll?: boolean;
}>(
    ({ blockScroll, theme: { font, palette, radius } }) => css`
        ${normalize};

        * {
            box-sizing: border-box;
        }

        input {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            border-radius: 0;
        }

        html {
            height: 100%;
            min-height: 100vh;
        }

        body {
            background: ${palette.neutral.white};
            font-family: ${font.primary};
            margin: 0;
            min-height: 100%;
            overflow-x: hidden;
            width: 100%;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            ${blockScroll && 'overflow-y: hidden;'}
        }

        #root {
            height: 100%;
            min-height: 100%;
        }

        svg {
            transition: all 0.5s;

            path,
            circle,
            rect {
                transition: all 0.5s;
            }
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input[type='number'] {
            -moz-appearance: textfield;
        }

        .sv-btn {
            border-radius: ${radius[7]}px;
        }

        // NOTE:: reset no-translate styles from WYSIWYG package
        .no-translate {
            color: ${palette.text.primary};

            &:before,
            &:after {
                content: '';
            }
        }
    `,
);

const fullWidthSectionCss = css`
    flex: auto;
    width: 100%;
`;

export const Container = styled.div<{ isDashboard?: boolean }>(
    ({ isDashboard }) => css`
        display: flex;
        flex-direction: column;
        height: 100%;
        ${isDashboard && 'justify-content: center;'};

        @media (max-width: ${breakpoints.lg}px) {
            padding: 0 25px;
        }

        @media (max-width: ${breakpoints.md}px) {
            padding: 0 15px;
        }

        @media (max-width: ${breakpoints.xxs}px) {
            padding: 0;
        }
    `,
);

export const ContainerInner = styled.div`
    display: flex;
    justify-content: space-between;

    @media (max-width: ${breakpoints.md}px) {
        flex-direction: column;
    }
`;

export const ContainerSection = styled.div<{ fullWidth?: boolean }>(
    ({ fullWidth }) => css`
        flex: 1;
        position: relative;

        ${fullWidth && fullWidthSectionCss};

        @media (max-width: ${breakpoints.md}px) {
            flex: auto;
        }
    `,
);
